import { render, staticRenderFns } from "./form-visualizar.vue?vue&type=template&id=0544a070"
import script from "./form-visualizar.vue?vue&type=script&lang=js"
export * from "./form-visualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports